export enum LorenAllConditionsEnum {
  BAROMETRIC_PRESSURE_HIGHER_THAN = "BAROMETRIC_PRESSURE_HIGHER_THAN",
  BAROMETRIC_PRESSURE_LOWER_THAN = "BAROMETRIC_PRESSURE_LOWER_THAN",
  CARBON_DIOXIDE_HIGHER_THAN = "CO2_HIGHER_THAN",
  CARBON_DIOXIDE_LOWER_THAN = "CO2_LOWER_THAN",
  CURRENT_HIGHER_THAN = "CURRENT_HIGHER_THAN",
  CURRENT_LOWER_THAN = "CURRENT_LOWER_THAN",
  DISTANCE_MORE_THAN = "DISTANCE_MORE_THAN",
  DISTANCE_LESS_THAN = "DISTANCE_LESS_THAN",
  EXTERNAL_CURRENT_HIGHER_THAN = "EXTERNAL_CURRENT_HIGHER_THAN",
  EXTERNAL_CURRENT_LOWER_THAN = "EXTERNAL_CURRENT_LOWER_THAN",
  EXTERNAL_VOLTAGE_HIGHER_THAN = "EXTERNAL_VOLTAGE_HIGHER_THAN",
  EXTERNAL_VOLTAGE_LOWER_THAN = "EXTERNAL_VOLTAGE_LOWER_THAN",
  FILL_LEVEL_EQUALS = "FILL_LEVEL_EQUALS",
  FLUID_FLOW_LOWER_THAN = "FLUID_FLOW_LOWER_THAN",
  FLUID_FLOW_HIGHER_THAN = "FLUID_FLOW_HIGHER_THAN",
  HUMIDITY_HIGHER_THAN = "HUMIDITY_HIGHER_THAN",
  HUMIDITY_LOWER_THAN = "HUMIDITY_LOWER_THAN",
  HCHO_HIGHER_THAN = "HCHO_HIGHER_THAN",
  HCHO_LOWER_THAN = "HCHO_LOWER_THAN",
  ILLUMINATION_HIGHER_THAN = "ILLUMINATION_HIGHER_THAN",
  ILLUMINATION_LOWER_THAN = "ILLUMINATION_LOWER_THAN",
  ITEM_COUNT_HIGHER_THAN = "ITEM_COUNT_HIGHER_THAN",
  ITEM_COUNT_LOWER_THAN = "ITEM_COUNT_LOWER_THAN",
  LIGHT_HIGHER_THAN = "LIGHT_HIGHER_THAN",
  LIGHT_LOWER_THAN = "LIGHT_LOWER_THAN",
  OZONE_HIGHER_THAN = "OZONE_HIGHER_THAN",
  OZONE_LOWER_THAN = "OZONE_LOWER_THAN",
  PM2_5_HIGHER_THAN = "PM2_5_HIGHER_THAN",
  PM2_5_LOWER_THAN = "PM2_5_LOWER_THAN",
  PM10_HIGHER_THAN = "PM10_HIGHER_THAN",
  PM10_LOWER_THAN = "PM10_LOWER_THAN",
  SOIL_MOISTURE_HIGHER_THAN = "SOIL_MOISTURE_HIGHER_THAN",
  SOIL_MOISTURE_LOWER_THAN = "SOIL_MOISTURE_LOWER_THAN",
  SOIL_TEMPERATURE_HIGHER_THAN = "SOIL_TEMPERATURE_HIGHER_THAN",
  SOIL_TEMPERATURE_LOWER_THAN = "SOIL_TEMPERATURE_LOWER_THAN",
  TEMPERATURE_HIGHER_THAN = "TEMPERATURE_HIGHER_THAN",
  TEMPERATURE_LOWER_THAN = "TEMPERATURE_LOWER_THAN",
  TVOC_IAQ_HIGHER_THAN = "TVOC_IAQ_HIGHER_THAN",
  TVOC_IAQ_LOWER_THAN = "TVOC_IAQ_LOWER_THAN",
  VOLTAGE_HIGHER_THAN = "VOLTAGE_HIGHER_THAN",
  VOLTAGE_LOWER_THAN = "VOLTAGE_LOWER_THAN",
  NTL_PROBABILITY_HIGHER_THAN = "NTL_PROBABILITY_HIGHER_THAN",
  ARCING_PROBABILITY_HIGHER_THAN = "ARCING_PROBABILITY_HIGHER_THAN",
  STATE_ON = "STATE_ON",
  STATE_OFF = "STATE_OFF",
  BINARY_IS_OPEN = "BINARY_IS_OPEN",
  BINARY_IS_CLOSED = "BINARY_IS_CLOSED",
  IGNITION_TRUE = "IGNITION_TRUE",
  IGNITION_FALSE = "IGNITION_FALSE",
  WATER_LEAK_TRUE = "WATER_LEAK_TRUE",
  WATER_LEAK_FALSE = "WATER_LEAK_FALSE",
  SMOKE_TRUE = "SMOKE_TRUE",
  SMOKE_FALSE = "SMOKE_FALSE",
  TILT_FALSE = "TILT_FALSE",
  TILT_TRUE = "TILT_TRUE",
  IN_AREA = "IN_AREA",
  OUT_OF_AREA = "OUT_OF_AREA",
  LIGHT_IS_BRIGHT = "LIGHT_IS_BRIGHT",
  LIGHT_IS_DARK = "LIGHT_IS_DARK",
  MOVEMENT_START = "MOVEMENT_START",
  MOVEMENT_STOP = "MOVEMENT_STOP",
}
